import React from 'react'

const Info = () => {
  return (
    <div className="about__info grid">
        <div className="about__box">
        <i class='bx bx-award about__icon'></i>
            <h3 className="about__title">Experience</h3>
            <span className="about__subtitle">3+ Years Web Development</span>
        </div>

        <div className="about__box">
        <i class='bx bx-briefcase-alt about__icon'></i>
            <h3 className="about__title">Projects</h3>
            <span className="about__subtitle">10+ websites & apps built</span>
        </div>

        <div className="about__box">
        <i class='bx bx-support about__icon'></i>
            <h3 className="about__title">Based in</h3>
            <span className="about__subtitle">Pointe-Claire, Montreal</span>
        </div>
    </div>
  )
}

export default Info